.ad{padding:0.5rem;}